import { useContext } from 'react';
import { EventContext } from '../context';

export function useEvents() {
  const context = useContext(EventContext);
  return { ...context };
}
